import { useEffect, useRef, useState } from 'react'
import { animate } from 'motion/react'
import { CartElementType } from 'src/lib/contexts/CartLayoutContext'

const HIGHLIGHT_OVERLAY_CLASS = 'absolute inset-0 pointer-events-none rounded-lg z-[9] bg-yellow-300/20 opacity-0'

export function useCartConfigItemHighlight(
  elementType: CartElementType,
  isSelected: boolean,
  selectedFromPreview: boolean,
  selectedElement: CartElementType | null,
  setSelectedElement: (payload: CartElementType | null, options?: { fromPreview?: boolean }) => void
) {
  const itemRef = useRef<HTMLDivElement>(null)
  const highlightRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const setSelectedElementRef = useRef(setSelectedElement)
  setSelectedElementRef.current = setSelectedElement

  useEffect(() => {
    if (!isSelected) return
    setIsOpen(true)
    const el = itemRef.current
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })

    if (!selectedFromPreview) return
    let cancelled = false
    const node = highlightRef.current
    if (node) {
      animate(node, { opacity: [0, 1, 0] }, { duration: 1, ease: 'easeInOut' }).then(() => {
        if (!cancelled) setSelectedElementRef.current(elementType, { fromPreview: false })
      })
    }
    return () => {
      cancelled = true
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected, selectedFromPreview, elementType])

  const handleValueChange = (value: string) => {
    setIsOpen(!!value)
    if (value) {
      if (selectedElement !== elementType) setSelectedElement(elementType)
    } else {
      setSelectedElement(null)
    }
  }

  return {
    itemRef,
    highlightRef,
    isOpen,
    handleValueChange,
    highlightOverlayClassName: HIGHLIGHT_OVERLAY_CLASS
  }
}
